import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import Quantity from 'components/global/Quantity'
import Price from 'components/shared/Price'
import {
    CreateReservationRoomDto,
    GetCartItemPresenter,
} from 'store/api-slice/hooks'

export interface SummaryItemAccommodationPromotionProps {
    items: GetCartItemPresenter[]
    totalPrice: number
    totalPriceWithoutDiscount: number
    rooms: CreateReservationRoomDto[]
    hasPromotion?: boolean
}

export const SummaryItemAccommodationPromotion = ({
    items,
    totalPrice,
    totalPriceWithoutDiscount,
    rooms,
    hasPromotion,
}: SummaryItemAccommodationPromotionProps) => {
    const roomsQuantity = hasPromotion
        ? 1
        : rooms
              .map((room) => room.quantity)
              .reduce((prev, next) => (prev || 0) + (next || 0))

    const bungalowsList = items.map((item, index) => {
        const { name, description } = item
        if (!name) return null

        const { quantity } = rooms[index]

        return new Array(quantity).fill(null).map((_, index) => (
            <Box key={index}>
                <Text variant="bodySmall" color="grayscale_900">
                    {name}
                </Text>
                {!!description && (
                    <Text variant="bodyExtraSmall" color="grayscale_700">
                        {description}
                    </Text>
                )}
            </Box>
        ))
    })

    return (
        <Box gap={8} direction="row">
            <Quantity value={roomsQuantity} size="small" />
            <Box gap={8} isFullWidth>
                {bungalowsList}
            </Box>
            <Box align="flex-end" mt={2}>
                <Price
                    size="bodyExtraSmall"
                    value={totalPrice}
                    color="primary_500"
                />
                <Price
                    crossedOutVariant="yellow"
                    color="grayscale_500"
                    size="bodyExtraSmall"
                    value={totalPriceWithoutDiscount}
                />
            </Box>
        </Box>
    )
}
